import React, { ReactElement } from 'react'
import { Authenticator } from '@aws-amplify/ui-react'
import './App.css'

const Authentication = (): ReactElement => {
  const components = {
    SignIn: {
      Footer () {
        return null
      }
    }
  }

  return (
    <div
      className='App'
    >
      <Authenticator
        hideSignUp
        components={components}
      />
    </div>
  )
}

export default Authentication
